import styled from "styled-components";
import {StyledBaseProps} from "@betrue/shared/interfaces";
import {IconButton, Slider, Stack} from "@mui/material";
import * as React from "react";
import {useRef, useState} from "react";
import CanvasDraw from "react-canvas-draw";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import DeleteIcon from '@mui/icons-material/Delete';

interface LogoDrawerViewProps extends StyledBaseProps {
  radius: number
  canvasWidth: number
  canvasHeight: number
  onChange: (image)=> void

}


function imageToDataUri(img, width, height, callback) {

  // create an off-screen canvas
  const canvas = document.createElement('canvas'),
    ctx = canvas.getContext('2d');
  const image = document.createElement('img')
  image.src = img
  // set its dimension to target size
  canvas.width = width;
  canvas.height = height;
  image.onload = function () {
    ctx.drawImage(image, 0, 0, width, height);
    callback(canvas.toDataURL());
  }

}

export const LogoDrawerView = styled((props: LogoDrawerViewProps) => {
  const canvas = useRef<any>()

  const [radius, setRadius] = useState(props.radius)

  return (<>
      <CanvasDraw mouseZoomFactor={2} hideGrid className={'logocanvas'} hideInterface={false} canvasWidth={512}
                  canvasHeight={512} ref={canvas} brushRadius={radius} onChange={()=> props.onChange(imageToDataUri(canvas.current?.getDataURL('png', false, '#FFF'), 1024,1024, (image)=> {
        props.onChange(image);
      }))} lazyRadius={props.radius}/>
      <Stack  direction="row" spacing={2} sx={{mb: 1}} alignItems="center">
        <EditIcon fontSize={'small'}/>
        <Slider min={2}
                max={30}

                defaultValue={6}
                aria-label="radius"
                value={radius}
                onChange={(e, value: number) => setRadius(value)}/>
        <EditIcon fontSize={'large'}/>
        <Divider sx={{height: 40, m: 0.5}} orientation="vertical"/>
        <IconButton onClick={() => {
          if (canvas) {
            canvas.current?.clear()
          }
        }} aria-label="delete">
          <DeleteIcon />
        </IconButton>
      </Stack>

    </>
  )
})
  `
    & {
    }
  `
